import { DummyStore } from 'stores';

import { Commission } from '../types/commissions.type';
import { CommissionResponse } from '../types/response.type';

export namespace CommissionsStore {
  export const commissions = new DummyStore<CommissionResponse>();
  export const editCommission = new DummyStore<Commission.TableRow | null>();
}
